import validate from "/builds/robustastudio/mazaya/pancho-v3/node_modules/.pnpm/nuxt@3.13.1_@parcel+watcher@2.4.1_@types+node@22.5.4_eslint@8.57.0_idb-keyval@6.2.1_ior_d030d0c852edf095f8900fce27f61b42/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/builds/robustastudio/mazaya/pancho-v3/node_modules/.pnpm/nuxt@3.13.1_@parcel+watcher@2.4.1_@types+node@22.5.4_eslint@8.57.0_idb-keyval@6.2.1_ior_d030d0c852edf095f8900fce27f61b42/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/robustastudio/mazaya/pancho-v3/middleware/auth.ts")
}